import React from "react";
import Character from "../Components/Character";

function CharSelect() {
  return (
    <>
      <Character />
    </>
  );
}

export default CharSelect;
